import { PrimaryLink, SecondaryLink } from "../components/Links";
import ServiciosMarquee from "../components/Marquee";
import Slider from "../components/Slider";

const beneficios = [
  {
    titulo: "Sin estrés",
    descripcion:
      "No perdés tiempo comparando opciones. Con un solo mensaje, nos ocupamos.",
  },
  {
    titulo: "Compromiso",
    descripcion:
      "Nos comprometemos a darte soluciones reales, de forma ágil y efectiva.",
  },
  {
    titulo: "Atención real",
    descripcion:
      "Siempre vas a hablar con una persona que te escucha y te entiende con un solo objetivo: ayudarte.",
  },
  {
    titulo: "Amplio horario de atención",
    descripcion:
      "Lunes a viernes de 8 a 20hs - sábados 8 a 13hs. Emergencias las 24hs para los servicios de plomeria, gas, electricidad y cerrajería.",
  },
];

const services = [
  {
    title: "Plomería",
    icon: "/iconos/grifo.png",
    description:
      "Reparaciones, instalaciones y mantenimiento de sistemas de agua",
    items: [
      "Reparación de fugas",
      "instalación de grifos",
      "destape de tuberías",
    ],
  },
  {
    title: "Electricidad",
    icon: "/iconos/enchufe.png",
    description: "Instalaciones eléctricas seguras y reparaciones certificadas",
    items: [
      "Instalación de luminarias",
      "reparación de cortocircuitos",
      "instalación de tomacorrientes",
    ],
  },
  {
    title: "Gasistas",
    icon: "/iconos/gasista.png",
    description: "Instalaciones y mantenimiento de sistemas de gas",
    items: [
      "Detección de fugas",
      "instalación de cocinas",
      "habilitación de gas",
    ],
  },
  {
    title: "Persianas",
    icon: "/iconos/persiana.png",
    description: "Reparación e instalación de persianas y cortinas metálicas",
    items: [
      "Reparación de mecanismos",
      "instalación de nuevas persianas",
      "automatización",
    ],
  },
  {
    title: "Cerrajería",
    icon: "/iconos/cerrajero.png",
    description: "Apertura de puertas, cambio de cerraduras y más",
    items: ["Apertura urgente", "cambio de cerraduras", "duplicado de llaves"],
  },
  {
    title: "Destapaciones",
    icon: "/iconos/destapador.png",
    description: "Servicios de destapaciones de cañerías y cloacas",
    items: [
      "Destapaciones urgentes",
      "cámaras cloacales",
      "mantenimiento preventivo",
    ],
  },
];

const Home = () => {
  return (
    <main className="">
      <Slider />
      <ServiciosMarquee />
      <section
        id="quienes-somos"
        className="bg-white container mx-auto py-12 md:py-24 lg:py-32 px-6"
      >
        <div className="max-w-7xl mx-auto">
          <h2 className="text-center text-secondary mb-10 md:mb-20">
            ¿Quienes somos?
          </h2>

          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div className="text-gray-700 text-base md:text-lg leading-relaxed">
              <p className="mb-4">
                Somos una empresa que, desde <strong>1992</strong>, brinda
                asistencia integral para el hogar, cubriendo la mayor variedad
                de <strong>servicios domiciliarios.</strong>
              </p>
              <p className="mb-4">
                Contamos con un centro especializado de atención, donde
                <strong> te escuchamos, acompañamos y aconsejamos</strong>.
              </p>
              <p className="mb-4">
                Ponemos a tu disposición a los mejores{" "}
                <strong>técnicos independientes, </strong>
                cuidadosamente seleccionados por su
                <strong> capacidad, honestidad y cordialidad</strong>.
              </p>
              <p className="font-semibold text-secondary mt-4">
                Formá parte de un mundo en servicios.
              </p>
              <PrimaryLink href="/asociarme" className="mt-6">
                Asociate
              </PrimaryLink>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 lg:gap-4 h-fit">
              {[
                {
                  icon: (
                    <svg
                      className="h-full w-full"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                        stroke="#1d2d44"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M12 6V12"
                        stroke="#1d2d44"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M16.24 16.24L12 12"
                        stroke="#1d2d44"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  ),
                  value: "+30",
                  label: "Años de experiencia",
                },
                {
                  icon: (
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-full w-full"
                    >
                      <path
                        d="M15.8 21C15.8 21.3866 16.1134 21.7 16.5 21.7C16.8866 21.7 17.2 21.3866 17.2 21H15.8ZM4.8 21C4.8 21.3866 5.1134 21.7 5.5 21.7C5.8866 21.7 6.2 21.3866 6.2 21H4.8ZM6.2 18C6.2 17.6134 5.8866 17.3 5.5 17.3C5.1134 17.3 4.8 17.6134 4.8 18H6.2ZM12.3 21C12.3 21.3866 12.6134 21.7 13 21.7C13.3866 21.7 13.7 21.3866 13.7 21H12.3ZM13.7 18C13.7 17.6134 13.3866 17.3 13 17.3C12.6134 17.3 12.3 17.6134 12.3 18H13.7ZM11.7429 11.3125L11.3499 10.7333L11.3499 10.7333L11.7429 11.3125ZM16.2429 11.3125L15.8499 10.7333L15.8499 10.7333L16.2429 11.3125ZM3.2 21V19.5H1.8V21H3.2ZM8 14.7H11V13.3H8V14.7ZM15.8 19.5V21H17.2V19.5H15.8ZM11 14.7C13.651 14.7 15.8 16.849 15.8 19.5H17.2C17.2 16.0758 14.4242 13.3 11 13.3V14.7ZM3.2 19.5C3.2 16.849 5.34903 14.7 8 14.7V13.3C4.57583 13.3 1.8 16.0758 1.8 19.5H3.2ZM11 14.7H15.5V13.3H11V14.7ZM20.3 19.5V21H21.7V19.5H20.3ZM15.5 14.7C18.151 14.7 20.3 16.849 20.3 19.5H21.7C21.7 16.0758 18.9242 13.3 15.5 13.3V14.7ZM6.2 21V18H4.8V21H6.2ZM13.7 21V18H12.3V21H13.7ZM9.5 11.3C7.67746 11.3 6.2 9.82255 6.2 8.00001H4.8C4.8 10.5958 6.90426 12.7 9.5 12.7V11.3ZM6.2 8.00001C6.2 6.17746 7.67746 4.7 9.5 4.7V3.3C6.90426 3.3 4.8 5.40427 4.8 8.00001H6.2ZM9.5 4.7C11.3225 4.7 12.8 6.17746 12.8 8.00001H14.2C14.2 5.40427 12.0957 3.3 9.5 3.3V4.7ZM12.8 8.00001C12.8 9.13616 12.2264 10.1386 11.3499 10.7333L12.1358 11.8918C13.3801 11.0477 14.2 9.61973 14.2 8.00001H12.8ZM11.3499 10.7333C10.8225 11.091 10.1867 11.3 9.5 11.3V12.7C10.4757 12.7 11.3839 12.4019 12.1358 11.8918L11.3499 10.7333ZM14 4.7C15.8225 4.7 17.3 6.17746 17.3 8.00001H18.7C18.7 5.40427 16.5957 3.3 14 3.3V4.7ZM17.3 8.00001C17.3 9.13616 16.7264 10.1386 15.8499 10.7333L16.6358 11.8918C17.8801 11.0477 18.7 9.61973 18.7 8.00001H17.3ZM15.8499 10.7333C15.3225 11.091 14.6867 11.3 14 11.3V12.7C14.9757 12.7 15.8839 12.4019 16.6358 11.8918L15.8499 10.7333ZM11.9378 5.42349C12.5029 4.97049 13.2189 4.7 14 4.7V3.3C12.8892 3.3 11.8667 3.68622 11.0622 4.33114L11.9378 5.42349ZM14 11.3C13.3133 11.3 12.6775 11.091 12.1501 10.7333L11.3642 11.8918C12.1161 12.4019 13.0243 12.7 14 12.7V11.3Z"
                        fill="#1d2d44"
                      ></path>
                    </svg>
                  ),
                  value: "+2500",
                  label: "Usuarios",
                },
                {
                  icon: (
                    <svg
                      fill="#1d2d44"
                      viewBox="0 0 36 36"
                      version="1.1"
                      preserveAspectRatio="xMidYMid meet"
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-full w-full"
                    >
                      <path
                        d="M20,14H16a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V15A1,1,0,0,0,20,14Zm-.4,6.6H16.4V15.4h3.2Z"
                        class="clr-i-outline clr-i-outline-path-1"
                      ></path>
                      <path
                        d="M33.71,12.38,29.62,8.29A1,1,0,0,0,28.92,8h-5V6.05A2,2,0,0,0,22,4H13.84A1.92,1.92,0,0,0,12,6.05V8H7.08a1,1,0,0,0-.71.29L2.29,12.38a1,1,0,0,0-.29.71V28a2,2,0,0,0,2,2H32a2,2,0,0,0,2-2V13.08A1,1,0,0,0,33.71,12.38ZM14,6h8V8H14ZM32,17H22v1.93H32V28H4V18.93H14V17H4V13.5L7.5,10h21L32,13.5Z"
                        class="clr-i-outline clr-i-outline-path-2"
                      ></path>
                      <rect
                        x="0"
                        y="0"
                        width="36"
                        height="36"
                        fill-opacity="0"
                      ></rect>
                    </svg>
                  ),
                  value: "+70",
                  label: "Técnicos independientes",
                },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="flex flex-col items-center justify-between text-center border hover:border-2 hover:border-blue-300 border-blue-200 rounded-lg p-6 bg-blue-50 transition"
                >
                  <div className="h-12 md:h-16 w-12 md:w-16 mb-2">
                    {item.icon}
                  </div>
                  <div className="flex flex-col">
                    <p className="text-base md:text-xl font-bold text-secondary">
                      {item.value}
                    </p>
                    <p className="text-gray-600 text-sm leading-4">{item.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section
        id="como-funciona"
        className="container px-6 mx-auto w-full py-12 md:py-24 lg:py-32 flex flex-col items-center"
      >
        <h2 className="text-secondary">Funcionamiento</h2>
        <div className="flex flex-col items-center pt-10 md:pt-20 max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row justify-center items-start gap-8 w-full">
            <div className="flex flex-col items-center justify-center w-full">
              <img
                src="/iconos/uno_funcion.png"
                alt="Paso 1"
                className="mx-auto w-40"
              />
              <h3 className="text-center mb-2">Pedido</h3>
              <p className="text-center max-w-[300px]">
                Nos contactas ante cualquier inconveniente en tu hogar y
                seleccionamos el técnico independiente ideal para vos.
              </p>
            </div>

            <div className="flex flex-col items-center justify-center w-full px-4">
              <img
                src="/iconos/dos_funcion.png"
                alt="Paso 4"
                className="mx-auto w-40"
              />
              <h3 className="text-center mb-2">Presupuesto</h3>
              <p className="text-center max-w-[300px]">
                El técnico seleccionado se comunica para pasarte presupuesto y
                coordinar una visita para realizar el trabajo.
              </p>
            </div>

            <div className="flex flex-col items-center justify-center w-full px-4">
              <img
                src="/iconos/tres_funcion.png"
                alt="Paso 3"
                className="mx-auto w-40"
              />
              <h3 className="text-center mb-2">Garantía</h3>
              <p className="text-center max-w-[300px]">
                Una vez finalizado el trabajo, el técnico seleccionado factura
                por la tarea realizada. Soluciones hogar efectúa una evaluación
                y junto con el profesional ofrecemos una garantía a todo trabajo
                técnico domiciliario.
              </p>
            </div>
          </div>
        </div>
        <span className="text-base text-center italic mt-10 md:mt-20 text-gray-500">
          “Es clave confiar en quién ingresa en tu hogar”
        </span>
      </section>

      <section className="relative w-full bg-gradient-to-r from-white via-white/90 to-transparent flex flex-col md:flex-row items-center justify-between overflow-hidden">
        <div className="flex flex-col items-start justify-center container px-6 mx-auto py-12 md:py-24 lg:py-32">
          <h2 className="text-secondary mb-6">Sin dolores de cabeza</h2>
          <ul className="flex gap-4 flex-col">
            {beneficios.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-secondary">
                <svg
                  className="h-6 w-6 min-w-min text-secondary"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="50"
                  height="50"
                  viewBox="0 0 50 50"
                >
                  <path d="M 25 2 C 12.317 2 2 12.317 2 25 C 2 37.683 12.317 48 25 48 C 37.683 48 48 37.683 48 25 C 48 20.44 46.660281 16.189328 44.363281 12.611328 L 42.994141 14.228516 C 44.889141 17.382516 46 21.06 46 25 C 46 36.579 36.579 46 25 46 C 13.421 46 4 36.579 4 25 C 4 13.421 13.421 4 25 4 C 30.443 4 35.393906 6.0997656 39.128906 9.5097656 L 40.4375 7.9648438 C 36.3525 4.2598437 30.935 2 25 2 z M 43.236328 7.7539062 L 23.914062 30.554688 L 15.78125 22.96875 L 14.417969 24.431641 L 24.083984 33.447266 L 44.763672 9.046875 L 43.236328 7.7539062 z"></path>
                </svg>
                <div>
                  <span className="text-lg font-semibold text-secondary">
                    {item.titulo}
                  </span>
                  <p className="text-sm text-gray-700">{item.descripcion}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <img
          src="/sofa.webp"
          alt="Relajada en sofa"
          className="w-full h-full absolute object-cover -z-20"
        />
      </section>

      <section id="profesionales" className="w-full py-12 md:py-24 lg:py-32">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="flex w-full lg:w-[50%] flex-col justify-center gap-8">
              <div className="flex flex-col gap-2">
                <span className="inline-block border text-secondary text-sm font-medium px-3 py-1 rounded-full my-0 md:my-4 w-fit">
                  100% Garantizado
                </span>
                <h2 className="text-gray-900">
                  Profesionales verificados con garantía
                </h2>
                <p className="text-gray-600 md:text-lg">
                  Todos nuestros profesionales pasan por un riguroso proceso de
                  verificación y ofrecemos garantía completa en todos los
                  trabajos técnicos domiciliarios.
                </p>
              </div>
              <div className="flex flex-col gap-4 ">
                {[
                  {
                    title: "Verificación Completa",
                    text: "Todos los profesionales que recomendamos pasan por un riguroso proceso de verificación.",
                  },
                  {
                    title: "Garantía",
                    text: "Garantía de 3 meses por cada trabajo técnico domiciliario.",
                  },
                  {
                    title: "Atención personalizada",
                    text: "Personas reales que te acompañan para encontrar la solución en tu hogar.",
                  },
                ].map((item, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <svg
                      className="w-7 h-7 shrink-0"
                      width="30px"
                      height="30px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      stroke="#fb923c"
                    >
                      <path
                        d="M8.5 12.5L10.5 14.5L15.5 9.5"
                        stroke="#fb923c"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                        stroke="#fb923c"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      ></path>
                    </svg>
                    <div>
                      <h3 className="text-gray-900">{item.title}</h3>
                      <p className="text-sm w-full text-gray-600">
                        {item.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <img
              className="rounded-xl w-full lg:w-[50%] object-right object-cover"
              src="/trabajador.webp"
              alt="trabajador"
            />
          </div>
        </div>
      </section>

      <section
        id="servicios"
        className="w-full py-12 md:py-24 lg:py-32 bg-white px-6 flex flex-col items-center container mx-auto"
      >
        <div className="flex flex-col items-center gap-4 ">
          <h2 className="">Servicios más solicitados</h2>
          <p className="max-w-[900px] text-gray-600 md:text-xl">
            Especialistas listos para ayudarte con los problemas más comunes del
            hogar
          </p>
          <div className="mx-auto grid max-w-5xl gap-6 py-12 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:gap-8">
            {services.map((service, i) => (
              <div
                key={i}
                className="border-2 hover:border-primary transition-colors rounded-lg p-6 flex flex-col items-center text-center space-y-3"
              >
                <img
                  src={service.icon}
                  alt={service.title}
                  className="h-20 w-20 object-contain"
                />
                <h3 className="font-semibold text-gray-900">{service.title}</h3>
                <p className="text-sm text-gray-500 italic">
                  {service.items.join(", ")}{"."}
                </p>
              </div>
            ))}
          </div>
        </div>
        <SecondaryLink
          className="flex items-center justify-center px-6 py-2 border h-fit w-max bg-white hover:bg-gray-100 text-black rounded-lg text-base font-bold"
          href="/servicios#todos-los-servicios"
        >
          Ver todos los servicios
        </SecondaryLink>
      </section>

      <section
        id="porque-elegirnos"
        className="min-h-screen w-full bg-gray-100"
      >
        <div className="container mx-auto px-6 py-12 md:py-20 lg:py-24 flex flex-col items-center">
          <h2 className="mb-10 md:mb-20">¿Por qué elegir Soluciones Hogar?</h2>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 w-full mx-auto text-left">
            <div className="flex flex-row items-start gap-4 max-w-[500px]">
              <img
                src="/iconos/Garage@2x.png"
                alt="Icono trayectoria"
                className="w-8 md:w-10 h-auto"
              />
              <div className="flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-gray-800 m-0">
                  Más de 30 años de trayectoria
                </h3>
                <p className="text-xs md:text-sm text-gray-600 m-0">
                  Miles de hogares ya confían en nosotros. Experiencia y
                  respaldo para solucionar cualquier inconveniente en casa.
                </p>
              </div>
            </div>

            <div className="flex flex-row items-start gap-4 max-w-[500px]">
              <img
                src="/iconos/UsersThree@2x.png"
                alt="Icono técnicos"
                className="w-8 md:w-10 h-auto"
              />
              <div className="flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-gray-800 m-0">
                  Técnicos confiables y verificados
                </h3>
                <p className="text-xs md:text-sm text-gray-600 m-0">
                  Seleccionamos a los mejores profesionales, asegurándonos de
                  que cuenten con referencias y experiencia comprobada.
                </p>
              </div>
            </div>

            <div className="flex flex-row items-start gap-4 max-w-[500px]">
              <img
                src="/iconos/ThumbsUp@2x.png"
                alt="Icono presupuesto"
                className="w-8 md:w-10 h-auto"
              />
              <div className="flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-gray-800 m-0">
                  Presupuestos sin cargo en tu hogar
                </h3>
                <p className="text-xs md:text-sm text-gray-600 m-0">
                  El profesional te puede decir un presupuesto aproximado del
                  trabajo por la información brindada y mediante fotos, el
                  precio exacto va a ser dado cuando vaya a tu domicilio.
                </p>
              </div>
            </div>

            <div className="flex flex-row items-start gap-4 max-w-[500px]">
              <img
                src="iconos/tool.png"
                alt="Icono soluciones"
                className="w-8 md:w-10 h-auto"
              />
              <div className="flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-gray-800 m-0">
                  Soluciones rápidas y sin complicaciones
                </h3>
                <p className="text-xs md:text-sm text-gray-600 m-0">
                  Olvidate de buscar prestadores por tu cuenta. Con una sola
                  llamada o mensaje, encontramos la mejor opción para vos.
                </p>
              </div>
            </div>

            <div className="flex flex-row items-start gap-4 max-w-[500px]">
              <img
                src="/iconos/HandHeart@2x.png"
                alt="Icono estrés"
                className="w-8 md:w-10 h-auto"
              />
              <div className="flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-gray-800 m-0">
                  No estás solo en momentos de estrés
                </h3>
                <p className="text-xs md:text-sm text-gray-600 m-0">
                  Cuando algo se rompe en casa, no tenés que resolverlo solo. Te
                  escuchamos, te asesoramos y buscamos la mejor solución para
                  vos.
                </p>
              </div>
            </div>

            <div className="flex flex-row items-start gap-4 max-w-[500px]">
              <img
                src="/iconos/Handshake@2x.png"
                alt="Icono personas"
                className="w-8 md:w-10 h-auto"
              />
              <div className="flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-gray-800 m-0">
                  Personas reales para resolver tu problema
                </h3>
                <p className="text-xs md:text-sm text-gray-600 m-0">
                  No hablás con bots ni con respuestas automáticas. Nuestro
                  equipo está disponible para escucharte y encontrar la mejor
                  solución, de persona a persona.
                </p>
              </div>
            </div>

            <div className="flex flex-row items-start gap-4 max-w-[500px]">
              <img
                src="/iconos/ChatsCircle@2x.png"
                alt="Icono garantía"
                className="w-8 md:w-10 h-auto"
              />
              <div className="flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-gray-800 m-0">
                  Seguimiento y garantía en cada trabajo
                </h3>
                <p className="text-xs md:text-sm text-gray-600 m-0">
                  Supervisamos cada servicio para asegurarnos de que el trabajo
                  se realice correctamente y con el respaldo de nuestra doble
                  garantía.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
